import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=3549fec6&scoped=true"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"
import style0 from "./ProfileIcon.vue?vue&type=style&index=0&id=3549fec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549fec6",
  null
  
)

export default component.exports